module.exports = __webpack_public_path__ + "assets/Jerald_Pamugas.b47824ad.pdf";